// extracted by mini-css-extract-plugin
module.exports = {"loader":"Hypnosis_loader__38qaw","outer":"Hypnosis_outer__11INM","middle":"Hypnosis_middle__1Fbvj","inner":"Hypnosis_inner__LlNGp","spin":"Hypnosis_spin__3TCN4"};